import {inView, animate, easeOut} from "motion"

class Logos {
    private logos: NodeListOf<HTMLElement>;
    private mousePosition = {x: 0, y: 0};
    private logoRects: DOMRect[] = [];

    constructor(private element: HTMLElement) {
        this.logos = this.element.querySelectorAll<HTMLElement>('img, svg');
        this.init();
    }

    private init() {
        const minDistance = 10;
        const maxDistance = 200 - minDistance;
        const maxMove = 4;

        window.addEventListener('mousemove', e => {
                this.mousePosition.x = e.clientX;
                this.mousePosition.y = e.clientY;

                inView(this.element, () => {
                    this.logos.forEach((logo, logo_i) => {
                        const rect = logo.getBoundingClientRect();
                        this.logoRects[logo_i] = rect;
                        const logoPos = {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2};
                        const distX = this.mousePosition.x - logoPos.x;
                        const distY = this.mousePosition.y - logoPos.y;
                        const distance = Math.sqrt(distX * distX + distY * distY) - minDistance;

                        if (distance >= 0) {
                            const angle = Math.atan2(distY, distX);
                            const moveAmount = Math.min(maxMove, (distance / maxDistance) * maxMove);

                            const moveX = Math.cos(angle) * moveAmount;
                            const moveY = Math.sin(angle) * moveAmount;

                            animate(logo, {
                                transform: `translate(${moveX}px, ${moveY}px)`
                            }, {
                                duration: 0
                            });
                        }
                    });
                });
            }
        )
    }
}

window.addEventListener('load', () => {
    const logoElements = document.querySelectorAll<HTMLElement>(".logos-component .component-logos");
    logoElements?.forEach((logo) => {
        new Logos(logo);
    });
});